import { SupportedChainId } from 'constants/chains'

type AddressMap = { [chainId: number]: string }

export const UNISWAP_NFT_AIRDROP_CLAIM_ADDRESS = '0x8B799381ac40b838BBA4131ffB26197C432AFe78'

export const V2_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.CRAT]: '',
  [SupportedChainId.CRAT_TESTNET]: '0x75ea5855d83e0A453b722a089Fcf65cDc8CD193F'
}
export const V2_ROUTER_ADDRESS: AddressMap = {
  [SupportedChainId.CRAT]: '',
  [SupportedChainId.CRAT_TESTNET]: '0x4272F8E9A2eEA6b853d40159Db33D662E5ca48dD',
}

export const PERMIT2_ADDRESS: AddressMap = {
  [SupportedChainId.CRAT]: '',
  [SupportedChainId.CRAT_TESTNET]: '0xD8775C8622e904f83d6B81A7005Ac3558CF589Bb',
}

// CRAT Testnet addresses
const CRAT_TESTNET_V3_CORE_FACTORY_ADDRESSES = '0x75ea5855d83e0A453b722a089Fcf65cDc8CD193F'
const CRAT_TESTNET_V3_MIGRATOR_ADDRESSES = ''
const CRAT_TESTNET_MULTICALL_ADDRESS = '0x2A8303756C0BAb5c6BA2e4aF2c3679146B61AEBB'
const CRAT_TESTNET_QUOTER_ADDRESSES = '0x1c2d444E9828Ce1A01FDf506008207480b9475ED'
const CRAT_TESTNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = '0xFCd8079d82D3b501c57937deE55D1462f094CE45'
const CRAT_TESTNET_TICK_LENS_ADDRESSES = '0xE95C65EB55D11D023A38296A0AaF658bAaB4B95e'
const CRAT_TESTNET_POOL_DEPLOYER = '0x68bCF5b94A8f1B86DE51f3A5473c9F8C5b4A69B4'
const CRAT_TESTNET_UNIVERSAL_ROUTER_ADDRESS = '0x9de044BcA422c9f7aD290fF5cE89f3d7d792741C'
const CRAT_TESTNET_V3_INIT_POOL_CODE_HASH = '0xb364a2767fd7be5e07942b1c94b422684dbabaf9ef55e1c92b13774b8fe0fc27'

// CRAT addresses
const CRAT_V3_CORE_FACTORY_ADDRESSES = ''
const CRAT_V3_MIGRATOR_ADDRESSES = ''
const CRAT_MULTICALL_ADDRESS = ''
const CRAT_QUOTER_ADDRESSES = ''
const CRAT_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = ''
const CRAT_TICK_LENS_ADDRESSES = ''
const CRAT_POOL_DEPLOYER = ''
const CRAT_UNIVERSAL_ROUTER_ADDRESS = ''
const CRAT_V3_INIT_POOL_CODE_HASH = ''

/* V3 Contract Addresses */
export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.CRAT_TESTNET]: CRAT_TESTNET_V3_CORE_FACTORY_ADDRESSES,
  [SupportedChainId.CRAT]: CRAT_V3_CORE_FACTORY_ADDRESSES,
}

export const V3_MIGRATOR_ADDRESSES: AddressMap = {
  [SupportedChainId.CRAT_TESTNET]: CRAT_TESTNET_V3_MIGRATOR_ADDRESSES,
  [SupportedChainId.CRAT]: CRAT_V3_MIGRATOR_ADDRESSES,
}

export const MULTICALL_ADDRESS: AddressMap = {
  [SupportedChainId.CRAT_TESTNET]: CRAT_TESTNET_MULTICALL_ADDRESS,
  [SupportedChainId.CRAT]: CRAT_MULTICALL_ADDRESS,
}

export const ARGENT_WALLET_DETECTOR_ADDRESS: AddressMap = {}

export const QUOTER_ADDRESSES: AddressMap = {
  [SupportedChainId.CRAT_TESTNET]: CRAT_TESTNET_QUOTER_ADDRESSES,
  [SupportedChainId.CRAT]: CRAT_QUOTER_ADDRESSES,
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.CRAT_TESTNET]: CRAT_TESTNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
  [SupportedChainId.CRAT]: CRAT_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
}

export const ENS_REGISTRAR_ADDRESSES: AddressMap = {}

export const TICK_LENS_ADDRESSES: AddressMap = {
  [SupportedChainId.CRAT_TESTNET]: CRAT_TESTNET_TICK_LENS_ADDRESSES,
  [SupportedChainId.CRAT]: CRAT_TICK_LENS_ADDRESSES,
}

export const POOL_DEPLOYER_ADDRESSES: AddressMap = {
  [SupportedChainId.CRAT_TESTNET]: CRAT_TESTNET_POOL_DEPLOYER,
  [SupportedChainId.CRAT]: CRAT_POOL_DEPLOYER,
}

export const UNIVERSAL_ROUTER_ADDRESS: AddressMap = {
  [SupportedChainId.CRAT_TESTNET]: CRAT_TESTNET_UNIVERSAL_ROUTER_ADDRESS,
  [SupportedChainId.CRAT]: CRAT_UNIVERSAL_ROUTER_ADDRESS,
}

export const V3_INIT_POOL_CODE_HASH: AddressMap = {
  [SupportedChainId.CRAT_TESTNET]: CRAT_TESTNET_V3_INIT_POOL_CODE_HASH,
  [SupportedChainId.CRAT]: CRAT_V3_INIT_POOL_CODE_HASH,
}
